import React from 'react';
import { FadeIn } from './FadeIn';
import { HeartIcon, SparklesIcon, UsersIcon } from 'lucide-react';
export function AudienceSection() {
  const audiences = [{
    icon: <HeartIcon className="w-6 h-6 text-bakery-amber" data-id="element-11" />,
    text: 'Latinos en USA que extrañan el sabor auténtico de su país.'
  }, {
    icon: <SparklesIcon className="w-6 h-6 text-bakery-amber" data-id="element-12" />,
    text: "Principiantes que nunca han tocado una masa y creen que 'no se les da la cocina'."
  }, {
    icon: <UsersIcon className="w-6 h-6 text-bakery-amber" data-id="element-13" />,
    text: 'Personas que quieren impresionar a sus visitas y familiares con pan casero real.'
  }];
  return <section className="bg-bakery-cream py-24 px-6" data-id="element-14">
      <div className="max-w-4xl mx-auto" data-id="element-15">
        <FadeIn className="text-center mb-12" data-id="element-16">
          <h2 className="text-4xl font-serif font-bold text-bakery-brown mb-4" data-id="element-17">
            ¿Para Quién Es Este Manual?
          </h2>
        </FadeIn>

        <div className="space-y-4" data-id="element-18">
          {audiences.map((item, index) => <FadeIn key={index} delay={index * 0.1} direction="left" data-id="element-19">
              <div className="flex items-center space-x-6 bg-white p-6 rounded-xl shadow-sm border border-bakery-tan" data-id="element-20">
                <div className="w-12 h-12 bg-bakery-cream rounded-full flex items-center justify-center flex-shrink-0" data-id="element-21">
                  {item.icon}
                </div>
                <p className="text-lg md:text-xl text-bakery-brown font-medium" data-id="element-22">
                  {item.text}
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}